import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ToggleActiveResponseSchema, ToggleActiveResponse } from "../response/PropertyActivationResponse";

const API_VERSION = "v4";

interface TogglePropertyActiveProps {
    id: string;
    is_active: boolean;
    /** Deactivate only: users to un-assign from the property. */
    unassign_user_ids?: string[];
}

/**
 * Toggles a property's Channex-active state. On success, `data.activation_id`
 * is either null (already in the requested state — no job was queued) or a
 * job id to poll via `usePropertyActivationStatus`.
 */
export const useTogglePropertyActive = () => {
    return useMutation({
        mutationKey: ['properties', 'toggle-active'],
        mutationFn: async ({ id, is_active, unassign_user_ids }: TogglePropertyActiveProps): Promise<ToggleActiveResponse> => {
            const response = await privateApi.patch(`/${API_VERSION}/property/${id}/activation`, {
                is_active,
                ...(!is_active && unassign_user_ids && unassign_user_ids.length > 0 && { unassign_user_ids }),
            });

            const validationResult = ToggleActiveResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid activation response format");
            }

            return validationResult.data;
        },
    });
};
